import { fetchQuery as relayFetchQuery } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { Observable } from 'relay-runtime';

import { startCaptureGraphQlErrors, stopCaptureGraphQlErrors } from '@atlassian/relay-errors';

import { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

export const fetchQuery = <TQuery extends OperationType>(
	...args: Parameters<typeof relayFetchQuery<TQuery>>
): Observable<TQuery['response']> => {
	const errorCollector = startCaptureGraphQlErrors();

	return Observable.create((sink) => {
		relayFetchQuery<TQuery>(...args).subscribe({
			next: (data) => {
				const errors = stopCaptureGraphQlErrors(errorCollector);
				if (errors.length > 0) {
					sink.error(new ApolloErrorInterop({ graphQLErrors: errors.flatMap((e) => e.errors) }));
				} else {
					sink.next(data);
					sink.complete();
				}
			},
			error: (error: Error) => {
				sink.error(error);
			},
			complete: () => {
				sink.complete();
			},
		});
	});
};
